export default "<app-header></app-header>\n<div class=\"main-content\">\n    <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n\n"